import lazyLoadActions from '../actions/lazyLoadActions'
import { BaseStore } from './baseStore'
import { getSingleElementByClass } from '../../utils/dom'
import scrollingEventsProvider from '../../providers/scrollingEventsProvider'

class LazyLoadStore extends BaseStore {
  constructor(options = {}) {
    super(options)
    this.load = false
  }

  routeAction(action) {
    let ACTIONS = lazyLoadActions.TYPES
    switch (action.type) {
      case ACTIONS.REACHED_LOAD_TARGET:
        this.load = this.load || true
        this.emitChange()
    }
  }

  emitChange() {
    return super.emitChange()
  }
}

let lazyLoadStore = LazyLoadStore.create()

export default lazyLoadStore



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/lazyLoadStore.js